import { useEffect, useState } from "react";
import { subscribeCatalogEntry } from "@/lib/firestore/catalog";
import type { CatalogEntry } from "@/types";

export function useCatalogEntry(projectId: string | null) {
  const [catalogEntry, setCatalogEntry] = useState<CatalogEntry | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!projectId) {
      setCatalogEntry(null);
      setLoading(false);
      setError(null);
      return;
    }

    setLoading(true);
    return subscribeCatalogEntry(
      projectId,
      (entry) => {
        setCatalogEntry(entry);
        setLoading(false);
        setError(null);
      },
      (err) => {
        setError(err.message);
        setLoading(false);
      },
    );
  }, [projectId]);

  return { catalogEntry, loading, error };
}
